import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { CaLandingPageComponent } from "../../ca-landing-page/ca-landing-page.component";
import { ToastrService } from "ngx-toastr";
import {
  ACTIONS,
  CAPERMIT_ACTIONS,
  CARRIER_ACTIONS,
  CARRIER_ACTION_TYPES,
  CARRIER_PERMIT_ACTIONS,
  INT_CARRIER_ACCOUNTS_ACTIONS,
  INT_CARRIER_ACCOUNTS,
  INT_PERMIT_APPROVALS,
  INT_PERMIT_APPROVALS_ACTIONS,
  PERMIT_FIRST_ACTIONS,
  PERMIT_ACTIONS,
  ACTION_TYPES,
  ADD_VEHICLE_ACTION_TYPES,
  VEHICLE_ACTION_TYPES,
  CARRIER_ACTION,
  CARRIER_TYPE_ACTIONS,
  TRANSPORT_ASSOCIATIONS,
  DOCUMENT_LINK_DELINK_ACTION,
} from "./actions.constants";
import { Action } from "./actions.interface";

import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";

@Component({
  selector: "app-actions",
  templateUrl: "./actions.component.html",
  styleUrls: ["./actions.component.scss"],
})
export class ActionsComponent implements OnInit {
  //On the basis of the actions passed as input, actions will be displayed on the UI
  @Input() actions: Array<Action> = [...CARRIER_ACTIONS];
  @Output() actionEvent = new EventEmitter<string>();
  @ViewChild(CaLandingPageComponent) landing: CaLandingPageComponent;
  @Input() selectedcarrier: any;
  @Input() selectedVehicle: any;
  @Input() user: any;
  @Input() selectedPermit: any;
  @Input() selectedPermitData: any;
  @Input() selectcarriertype: any;
  @Input() isVehicleActions: boolean = false;
  constructor(
    private router: Router,
    private toastService: ToastNotificationService,
    private toaster: ToastrService
  ) {}

  ngOnInit(): void {
    this.checkScreen();
  }

  checkScreen() {
    // Feed your actions based on screen(Use url)
    if (this.router.url.indexOf("carrier/application-permit") != -1) {
      this.actions = [...CARRIER_PERMIT_ACTIONS];
    }
    if (this.router.url.indexOf("account/approval") != -1) {
      this.actions = [...INT_CARRIER_ACCOUNTS_ACTIONS];
    }
    if (this.router.url.indexOf("carrier/permit/application") != -1) {
      this.actions = [...PERMIT_FIRST_ACTIONS];
    }
    if(this.isVehicleActions){
      this.actions = [...VEHICLE_ACTION_TYPES];
    }
    if (this.router.url.indexOf("permit/my-vehicles") != -1) {
      this.actions = [...VEHICLE_ACTION_TYPES];
    }
    if (this.router.url.indexOf("permit/vehicles") != -1) {
      this.actions = [...VEHICLE_ACTION_TYPES];
    }
    if (this.router.url.indexOf("permit/approval") != -1) {
      this.actions = [...INT_PERMIT_APPROVALS_ACTIONS];
    }
    if (this.router.url.indexOf("permit/application/mypermits") != -1) {
      this.actions = [...ACTIONS];
    }
    if (this.router.url.indexOf("/carrier/type/list") != -1) {
      this.actions = [...CARRIER_ACTION];
    }
    if (this.router.url.indexOf("/transport/association/list") != -1) {
      this.actions = [...TRANSPORT_ASSOCIATIONS];
    }
    if (this.router.url.indexOf("/permit/documenttype/list") != -1) {
      this.actions = [...DOCUMENT_LINK_DELINK_ACTION];
    }
  }

  validation(value: any) {
    //Validations for clicked checkbox
    if (
      this.selectedPermit === null &&
      this.router.url.indexOf("carrier/permit/application") !== -1 &&
      value.value !== PERMIT_ACTIONS.ApplyApplication
    ) {
      return this.toastService.error(
        "Please select the application first!",
        "Warning"
      );
    }
    if (
      value.value === PERMIT_ACTIONS.CancelApplication &&
      this.selectedPermit.status !== "Submitted_1" &&
      this.router.url.indexOf("carrier/permit/application") !== -1
    ) {
      console.log("val", this.selectedPermit.status_code);
      return this.toastService.error(
        "You can only cancel submitted applications!",
        "Cancel Application"
      );
    }
    // if (
    //   this.selectedVehicle === null &&
    //   this.router.url.indexOf("permit/my-vehicles") !== -1 &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.Delete &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.AddVehicle
    // ) {
    //   return this.toastService.error(
    //     "Please select the vehicle first!",
    //     "Warning"
    //   );
    // }
    // if (
    //   this.selectedVehicle === null &&
    //   this.router.url.indexOf("permit/my-vehicles") !== -1 &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.View &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.AddVehicle
    // ) {
    //   return this.toastService.error(
    //     "Please select the vehicle first!",
    //     "Warning"
    //   );
    // }
    // if (
    //   this.selectedVehicle === null &&
    //   this.router.url.indexOf("permit/my-vehicles") !== -1 &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.UpdateHistory &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.AddVehicle
    // ) {
    //   return this.toastService.error(
    //     "Please select the vehicle first!",
    //     "Warning"
    //   );
    // }
    if (
      this.selectedVehicle === null &&
      this.router.url.indexOf("permit/my-vehicles") !== -1 &&
      value.value !== ADD_VEHICLE_ACTION_TYPES.UploadDocuments &&
      value.value !== ADD_VEHICLE_ACTION_TYPES.AddVehicle
    ) {
      return this.toastService.error(
        "Please select the vehicle first!",
        "Warning"
      );
    }
    // if (
    //   this.selectedVehicle === null &&
    //   this.router.url.indexOf("permit/vehicles") !== -1 &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.Delete &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.AddVehicle
    // ) {
    //   return this.toastService.error(
    //     "Please select the vehicle first!",
    //     "Warning"
    //   );
    // }
    // if (
    //   this.selectedVehicle === null &&
    //   this.router.url.indexOf("permit/vehicles") !== -1 &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.View &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.AddVehicle
    // ) {
    //   return this.toastService.error(
    //     "Please select the vehicle first!",
    //     "Warning"
    //   );
    // }
    // if (
    //   this.selectedVehicle === null &&
    //   this.router.url.indexOf("permit/vehicles") !== -1 &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.UpdateHistory &&
    //   value.value !== ADD_VEHICLE_ACTION_TYPES.AddVehicle
    // ) {
    //   return this.toastService.error(
    //     "Please select the vehicle first!",
    //     "Warning"
    //   );
    // }
    if (
      this.selectedVehicle === null &&
      this.router.url.indexOf("ocas-stepper") !== -1 &&
      value.value === ADD_VEHICLE_ACTION_TYPES.UploadDocuments &&
      value.value !== ADD_VEHICLE_ACTION_TYPES.AddVehicle
    ) {
      return this.toastService.error(
        "Please select the vehicle first!",
        "Warning"
      );
    }
    if (
      this.selectedVehicle === null &&
      this.router.url.indexOf("permit/vehicles") !== -1 &&
      value.value !== ADD_VEHICLE_ACTION_TYPES.UploadDocuments &&
      value.value !== ADD_VEHICLE_ACTION_TYPES.AddVehicle
    ) {
      return this.toastService.error(
        "Please select the vehicle first!",
        "Warning"
      );
    }
    if(this.selectedcarrier !== null){
    if (
      value.value === CAPERMIT_ACTIONS.MyApplications &&
      this.selectedcarrier.status_code !== "Submitted_1" &&
      this.selectedcarrier.status_code !== "Approved" &&
      this.selectedcarrier.status_code !== "Change_sub"
    ) {
      return this.toastService.error(
        "Your carrier account status is not submitted or approved!",
        "Warning"
      );
    }
  }
    if (
      value.value === CAPERMIT_ACTIONS.MyPermits &&
      this.selectedcarrier.status_code !== "Submitted_1" &&
      this.selectedcarrier.status_code !== "Approved"  &&
      this.selectedcarrier.status_code !== "Change_sub"
    ) {
      return this.toastService.error(
        "Your carrier account status is not submitted or approved!",
        "Error"
      );
    }

    if (
      value.value === CARRIER_ACTION_TYPES.Unsubmit &&
      this.selectedcarrier != null &&
      this.selectedcarrier.status_code !== "Submitted_1" &&
      this.selectedcarrier.status_code !== "Approved"  &&
      this.selectedcarrier.status_code !== "Change_sub"
    ) {
      return this.toastService.error(
        "Your carrier account status is not submitted or approved!",
        "Warning"
      );
    }

    if (
      this.selectedcarrier === null &&
      this.router.url.indexOf("account/approval") != -1
    ) {
      return this.toastService.error(
        "Please select the account first!",
        "Warning"
      );
    }
    if (
      this.selectedcarrier === null &&
      this.router.url.indexOf("ocas/questionnaire") != -1
    ) {
      return this.toastService.error(
        "Please select the account first!",
        "Warning"
      );
    }

    if (
      this.selectedcarrier === null &&
      this.router.url.indexOf("carrier/application-permit") != -1
    ) {
      return this.toastService.error(
        "Please select the account first!",
        "Warning"
      );
    }

    if (
      this.selectedcarrier === null &&
      this.router.url.indexOf("monthly-compliance/list") != -1
    ) {
      return this.toastService.error(
        "Please select the account first!",
        "Warning"
      );
    }

    if (
      this.selectedcarrier === null &&
      this.router.url.indexOf("carrier/reports") != -1
    ) {
      return this.toastService.error(
        "Please select the account first!",
        "Warning"
      );
    }


    if (
      value.value === CARRIER_ACTION_TYPES.LinkConsultants &&
      this.selectedcarrier.lead_user_id !== this.user.Id &&
      this.selectedcarrier.status_code !== "Approved"
    ) {
      return this.toastService.error(
        "Your carrier account is not approved and you are not lead user!",
        "Error"
      );
    }

    if (
      value.value === CARRIER_ACTION_TYPES.FundAccount &&
      this.selectedcarrier.lead_user_id !== this.user.Id &&
      this.selectedcarrier.status_code !== "Approved"
    ) {
      return this.toastService.error(
        "Your carrier account is not approved and you are not lead user!",
        "Error"
      );
    }
    if (
      value.value === CARRIER_ACTION_TYPES.MyCarrierPermits &&
      this.selectedcarrier === null
    ) {
      return this.toastService.error(
        "Please select the account first!",
        "Warning"
      );
    }

    // if (
    //     value.value === CARRIER_ACTION_TYPES.ViewOcas &&
    //     this.selectedcarrier.status_code !== "Submitted_1" &&
    //     this.selectedcarrier.status_code !== "Approved"
    // ) {
    //   return this.toastService.error(
    //       "Your carrier account is not approved and you are not lead user!",
    //       "Error"
    //   );
    // }

    if (
      this.selectedcarrier === null &&
      this.router.url.indexOf("carrier/accounts") != -1
    ) {
      return this.toastService.error(
        "Please select the account first!",
        "Warning"
      );
    }
    // if (
    //   value.value === CAPERMIT_ACTIONS.AnnualCompliance &&
    //   this.selectedcarrier.status_code !== "Approved"
    // ) {
    //   //&& (this.selectedcarrier.status_code == 'Approved'
    //   return this.toastService.error(
    //     "Your carrier account is approved!",
    //     "Error"
    //   );
    // }
    if (
      value.value === CARRIER_ACTION_TYPES.AccountStatement &&
      this.selectedcarrier.status_code !== "Submitted_1" &&
      this.selectedcarrier.status_code !== "Approved"  &&
      this.selectedcarrier.status_code !== "Change_sub"
    ) {
      //
      return this.toastService.error(
        "Your carrier account status is not submitted or approved!",
        "Warning"
      );
    }
    if (
      this.selectedcarrier === null &&
      this.router.url.indexOf("carrier/accounts") != -1
    ) {
      return this.toastService.error(
        "Please select the account first!",
        "Warning"
      );
    }

    if (
      this.selectedcarrier === null &&
      this.router.url.indexOf("permit/approval") != -1
    ) {
      return this.toastService.error(
        "Please select the permit first!",
        "Warning"
      );
    }
    if (
      this.selectedPermitData === null &&
      this.router.url.indexOf("permit/application/mypermits") != -1 &&
      value.value !== ACTION_TYPES.ApplyPermit
    ) {
      return this.toastService.error(
        "Please select the permit first!",
        "Warning"
      );
    }
    // if (this.selectedPermitData == null && this.router.url.indexOf('permit/type/list') != -1 && value.value !== ACTION_TYPES.AddPermitType) {
    //   return this.toaster.warning('Please select the permit type first!')
    // }
    // console.log(this.selectedPermitData)
    // if(value.value === ACTION_TYPES.EditPermit && (this.selectedPermitData.application.status_id > 1)){
    //   return this.toaster.warning('This permit can not be edited, bacause status is '+this.selectedPermitData.application.status);
    // }
  }

  onClickAction(value: any) {
    this.actionEvent.emit(value);
    console.log(value);

    if (
      this.router.url.indexOf("/carrier/type/list") == -1 &&
      this.router.url.indexOf("/transport/association/list") == -1 &&
      this.router.url.indexOf("/permit/documenttype/list") == -1
    ) {
      // VALIDATIONScarrier/accounts/VCA
      this.validation(value);
      //ACTIONS
      this.actionMethods(value);
    }
  }

  actionMethods(value: any) {
    //Carrier list Screens
    if (value.value === CARRIER_ACTION_TYPES.ViewAccount) {
      document.getElementById("actionViewAccount").click();
    }
    // if(value.value === CARRIER_ACTION_TYPES.EditAccount){
    //   document.getElementById('actionEditAccount').click();
    // }
    if (value.value === CARRIER_ACTION_TYPES.Unsubmit) {
      document.getElementById("actionUnSubmit").click();
    }
    if (value.value === CARRIER_ACTION_TYPES.AccountStatement) {
      document.getElementById("actionAccountStatement").click();
    }
    if (value.value === CARRIER_ACTION_TYPES.ViewOcas) {
      document.getElementById("actionOCAS").click();
    }
    if (value.value === CARRIER_ACTION_TYPES.OcasAudit) {
      document.getElementById("ocasAuditBtn").click();
    }
    if (value.value === CARRIER_ACTION_TYPES.MyCarrierPermits) {
      document.getElementById("MyPermitBtn").click();
    }
    if (value.value === CARRIER_ACTION_TYPES.MonthlyCompliance) {
      document.getElementById("monthlyCompliance").click();
    }
    if (value.value === CARRIER_ACTION_TYPES.CarrierReports) {
      document.getElementById("carrierReports").click();
    }
    if (value.value === CAPERMIT_ACTIONS.MyPermits) {
      document.getElementById("actionPermit").click();
    }
    if (value.value === CAPERMIT_ACTIONS.MyApplications) {
      document.getElementById("actionApplication").click();
    }
    if (value.value === CARRIER_ACTION_TYPES.LinkConsultants) {
      document.getElementById("actionConsultants").click();
    }
    if (value.value === CARRIER_ACTION_TYPES.FundAccount) {
      document.getElementById("fundMyAccount").click();
    }
    // if(value.value === CAPERMIT_ACTIONS.AnnualCompliance){
    //   document.getElementById('actionCompliance').click();
    // }

    //Carrier Internal Screen
    if (value.value === CAPERMIT_ACTIONS.AnnualCompliance) {
      document.getElementById("actionCompliance").click();
    }
    if (value.value === INT_CARRIER_ACCOUNTS.ProcessAccount) {
      document.getElementById("processAcc").click();
    }

    if (value.value === INT_CARRIER_ACCOUNTS.ViewAccount) {
      document.getElementById("viewAcc").click();
    }

    //Applications list Screen
    if (value.value === PERMIT_ACTIONS.ApplyApplication) {
      document.getElementById("actionApplyPermit").click();
    }
    if (value.value === PERMIT_ACTIONS.ApplyApplication) {
      document.getElementById("actionApplyPermit").click();
    }

    if (
      value.value === PERMIT_ACTIONS.CancelApplication &&
      this.selectedPermit.status === "Submitted_1"
    ) {
      document.getElementById("actionCancelApplication").click();
    }
    if (value.value === ACTION_TYPES.ApplyPermit) {
      document.getElementById("actionApplyPermit2").click();
    }

     if (value.value === ACTION_TYPES.ReplaceVehicle) {
      document.getElementById('actionChangeVehicle').click();
    }
     if (value.value === ACTION_TYPES.Renew) {
      document.getElementById('actionRenewPermit').click();
    }
    if (value.value === ACTION_TYPES.DuplicatePermit) {
      document.getElementById('actionDuplicatePermit').click();
    }
    if (value.value === ACTION_TYPES.ErrorCorrection) {
      document.getElementById('actionCorrection').click();
    }
    if (value.value === ACTION_TYPES.ChangeRoute) {
      document.getElementById('actionRoute').click();
    }
    //Add Vehicle
    if (value.value === ADD_VEHICLE_ACTION_TYPES.AddVehicle) {
      document.getElementById("actionAddVehicle").click();
    }
    if (value.value === ADD_VEHICLE_ACTION_TYPES.UploadDocuments) {
      document.getElementById("actionUploadDocuments").click();
    }

  }
}
